import { render, staticRenderFns } from "./activePoliciesTable.vue?vue&type=template&id=69fdebc9&"
import script from "./activePoliciesTable.vue?vue&type=script&lang=js&"
export * from "./activePoliciesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports